import React from "react";

const NavItems = ({ nav }) => {
  return (
    <li className="nav-item">
      {/* href="#" */}
      <a className="nav-link collapsed">
        <i className={nav.icon}></i>
        <span>{nav.name}</span>
      </a>
    </li>
  );
};

export default NavItems;
